
import PreviewDevice from '@/components/PreviewDevice';
import PreviewAction from '@/views/creative/components/preview-action.vue';
import ReloadBtn from './previewDialog/reloadBtn.vue';
import { language } from '@/common/storage';
export default {
  props: {
    previewUrl: [String]
  },
  components: {
    PreviewDevice: PreviewDevice,
    PreviewAction: PreviewAction,
    ReloadBtn: ReloadBtn
  },
  data: function data() {
    return {
      condition: {
        orientation: 1,
        deviceType: 3
      },
      loading: false,
      preview_url: ''
    };
  },

  methods: {
    // 重新加载
    handleReload: function handleReload() {
      var _this = this;

      this.preview_url = '';
      this.$nextTick(function () {
        _this.preview_url = _this.cookPreviewUrl(_this.previewUrl);
      });
    },

    // 添加PL的loading
    cookPreviewUrl: function cookPreviewUrl(url) {
      if (!url) return '';
      return '' + url + (url.indexOf('?') === -1 ? '?' : '&') + 'loading=1&preview=true&lang=' + language.get();
    }
  },
  mounted: function mounted() {
    if (this.previewUrl) {
      this.preview_url = this.cookPreviewUrl(this.previewUrl);
    }
  },

  watch: {
    // 弹窗一出现就loading
    'config.visible': function configVisible(val) {
      this.preview_url = '';
      if (val) {
        this.loading = true;
        // 防止多次预览同一个url而不结束loading
        if (this.previewUrl) {
          this.preview_url = this.cookPreviewUrl(this.previewUrl);
        }
      }
    },

    // 传入的url
    previewUrl: function previewUrl(url) {
      if (url) {
        this.preview_url = this.cookPreviewUrl(url);
      }
    },

    // 实际预览的url
    preview_url: function preview_url(url) {
      if (url) {
        this.loading = false;
      }
    }
  }
};